import { render, staticRenderFns } from "./AttachmentSelection.vue?vue&type=template&id=1b914d21&scoped=true&"
import script from "./AttachmentSelection.vue?vue&type=script&lang=ts&"
export * from "./AttachmentSelection.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentSelection.vue?vue&type=style&index=0&id=1b914d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b914d21",
  null
  
)

export default component.exports